// extracted by mini-css-extract-plugin
export default {"newShippingAddress":"shipping_newShippingAddress__rV2pe"};